export default (props, vars) => props?.['student']?.fullName;
